import { BASE_CHAT_PATH } from './BASE_CHAT_PATH';
const pathIncludesChatPath = () => window.location.pathname.includes(BASE_CHAT_PATH);
export { pathIncludesChatPath as default, pathIncludesChatPath };